import React, { createContext, useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import { generateCsvFile } from "../helper";
import { toast } from "react-toastify";

const PUBLIC_ROUTES = ["/", "/auth", "/terms.html", "/privacy.html", "/delete-account"];

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialLangRef = useRef();
  const fallbackLang = "en";

  const [selectedLang, setSelectedLang] = useState("en");
  const languages = ["en", "hi", "fr", "de", "es", "ja"];

  const languageLabels = {
    en: "English",
    hi: "Hindi",
    fr: "French",
    de: "German",
    es: "Spanish",
    ja: "Japanese",
  };

  // `selectedLang` picks which translation of the content a form edits. The
  // panel's labels stay English whatever it is — see src/i18n.js.

  const [adminInfo, setAdminInfo] = useState({});

  useEffect(() => {
    const adminData = localStorage.getItem("user");
    setAdminInfo(JSON.parse(adminData));

    const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);
    if (!adminData && !isPublicRoute) {
      navigate("/auth");
    }
  }, [navigate, location.pathname]);

  const [isShowCSVModalVisible, setIsShowCSVModalVisible] = useState(false);

  const handleCloseCSV = () => {
    setIsShowCSVModalVisible(false);
  };

  // `fileLabel` names the file kind in the toast — "Excel" for the
  // recommenders workbook, "CSV" for everything else.
  const handleGenerateCSV = async (title, filters, fileLabel = "CSV") => {
    handleCloseCSV();
    // Reported on what happened, not on having tried: this used to announce
    // success even when nothing was downloaded. The message is a string —
    // react-toastify renders its content as a child, and an object is not one.
    const saved = await generateCsvFile(adminInfo.token, title, filters);
    if (saved) {
      toast.success(`The ${title} ${fileLabel} has been downloaded.`);
    } else {
      toast.error(`The ${title} ${fileLabel} could not be generated.`);
    }
  };

  return (
    <LanguageContext.Provider value={{
      languages,
      languageLabels,
      selectedLang,
      setSelectedLang,
      adminInfo,
      initialLangRef,
      fallbackLang,
      isShowCSVModalVisible,
      setIsShowCSVModalVisible,
      handleCloseCSV,
      handleGenerateCSV
    }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);

  return context;
};
